import manifest_45route_45rule from "/builds/macys/polaris/nuxt-app/homepage/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  manifest_45route_45rule
]
export const namedMiddleware = {}